<template>
  <section class="text-center py-12 min-h-screen-3/4">
    <h1 class="text-3xl text-blue mt-4">Payment information</h1>

    <div
      class="bg-white p-8 max-w-screen-xs md:max-w-screen-sm mx-auto text-base text-left my-12 form"
    >
      <div id="card-element">
        <!-- Elements will create input elements here -->
      </div>

      <div role="alert" v-html="errors"></div>

      <div class="flex items-center justify-center mt-8">
        <button
          @click="onPay()"
          class="bg-primary text-white rounded-full px-[30px] md:px-[35px] py-5 font-bold text-[22px] leading-[14px]"
          :class="{ 'opacity-25': isBusy }"
          :disabled="isBusy"
        >
          Donate
        </button>
      </div>
    </div>

    <div
      class="mx-auto max-w-screen-xs text-base text-blue-lighter italic px-4"
    >
      <p>Your donation is processed securely by our payment partner Stripe.</p>
    </div>
  </section>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js/pure";

const cardStyle = {
  base: {
    backgroundColor: "#ffffff",
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontWeight: "bold",
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4"
    }
  },
  invalid: {
    color: "#d75f54",
    iconColor: "#fa755a"
  }
};

export default {
  props: {
    publicKey: String,
    clientSecret: String
  },

  data() {
    return {
      isBusy: true,
      stripe: null,
      elements: null,
      card: null,
      errors: null
    };
  },

  computed: {},

  methods: {
    init(instance) {
      this.stripe = instance;
      this.elements = this.stripe.elements();
      this.card = this.elements.create("card", { style: cardStyle });
      this.card.mount("#card-element");
      this.card.on("change", ({ error }) => {
        if (error) {
          this.errors = error.message;
        } else {
          this.errors = "";
        }
      });

      this.isBusy = false;
    },

    handlePayResult(result) {
      if (result.error) {
        this.errors = result.error.message;
        this.$emit("save", {
          status: "failed",
          comments: result.error.message
        });
        this.isBusy = false;
        return;
      }

      if (result.paymentIntent.status !== "succeeded") {
        console.log(result.paymentIntent);
        this.errors = result.paymentIntent.status;
        this.$emit("save", {
          status: "failed",
          comments: result.paymentIntent.status
        });
        this.isBusy = false;
        return;
      }

      this.$emit("save", {
        status: "received",
        comments: null
      });
    },

    onPay() {
      this.isBusy = true;
      this.stripe
        .confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.card
          }
        })
        .then(this.handlePayResult);
    }
  },

  mounted() {
    if (!this.publicKey) return;

    loadStripe(this.publicKey).then(this.init);
  }
};
</script>
